import { Injectable } from '@angular/core';
import { DatabaseGwService } from '../database-gw.service';

@Injectable({
  providedIn: 'root'
})
export class SaleOrderDetailService extends DatabaseGwService {
  URL_PATH: string = "/sale-order-details";
}
